module.exports = __webpack_public_path__ + "static/media/8H.f6325833.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8H.svg
// module id = 79
// module chunks = 0